import styled from 'styled-components';
import { MainBtn } from 'components/Buttons';

export const VerifyCodeContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(122deg, rgb(235 161 198 / 58%) 0%, #fff6fb 40%);
`;

export const FormContainer = styled.div`
  width: 90%;
  max-width: 900px;
  margin: 90px auto;
  background-color: #fff;
  border-radius: 15px;
  padding: 60px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    margin-top: 60px;
    margin-bottom: 60px;
    padding: 40px 20px;
  }

  .logo-wrapper {
    text-align: center;

    img {
      width: 230px;
    }
  }

  h4.information{
    font-size: 15px;
  }

  h4.information b{
    font-weight: 800;
    color: var(--primary-color);
  }

  h4.label{
    margin-top: 10px;
    font-size: 15px;
  }

  .title {
    margin-top: 28px;
    margin-bottom: 60px;
    color: var(--primary-color);
    text-align: center;

    h2 {
      font-size: var(--font-larger);
      font-weight: bolder;
    }

    h4 {
      margin-top: 18px;
    }
  }

  .form-footer {
    margin-top: 50px;

    p {
      text-align: center;
      color: var(--primary-color);
      margin-bottom: 15px;
      cursor: pointer;
    }
  }

  .container-btns {
    display: flex;
    align-items: center;
    gap: 40px;
    justify-content: flex-end;
    margin-top: 80px;
    p {
      font-size: 14px;
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
      color: var(--secondary-color-light);
    }
  }

  .space-text {
    margin-bottom: 40px;
  }

  .space-text-2 {
    margin-bottom: 35px;

    h5 {
      margin-bottom: 5px;
    }
  }
`;

export const CodeInput = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  justify-content: center;


  input[type='number'] {
    text-align: center;
    width: 64px;
    height: 80px;
    border: 1.5px solid var(--secondary-color);
    color: var(--secondary-color);
    outline: none;

    position: relative;
    z-index: 99999;

    :focus {
      border: 2px solid var(--third-color-dark);
    }
    @media (min-width: 998px) {
      font-size: 38px;
    }
    @media (max-width: 997px) {
      width: 30px;
      height: 40px;
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
  @media (max-width: 997px) {
    gap: 10px;
    justify-content: space-around;
    max-width: 400px;
    margin: 0 auto;
  }
`;


export const MainButton = styled(MainBtn)`
  float: right;
  width: 40%;
  height: 30px;
  font-weight: bold;
  font-size: var(--font-medium);
  

  .icon {
    width: 12px;
  }
`;
